export default __webpack_public_path__ + "static/media/Porpoise Tropical Fish Food Pellet.3dc6d4f0.png";